function NotFound404(): JSX.Element {
  return <div>Halaman tidak ditemukan</div>;
}

export default NotFound404;
